type ChooseYourDocuments = {
  pocket_option_is_checked: boolean;
  wealth_option_is_checked: boolean;
  selected_investment_product_ids: Array<string>;
}

export default class State {
  choose_your_documents_data: ChooseYourDocuments = {
    pocket_option_is_checked: false,
    wealth_option_is_checked: false,
    selected_investment_product_ids: [],
  };
}
